import axiosInstance from '@/utils/api.js'

var state = {
  coefficientScheme: []
}

var getters = {
  COEFFICIENT_SCHEME: (state) => {
    return state.coefficientScheme
  }
}

var mutations = {
  SET_COEFFICIENT_SCHEME: (state, payload) => {
    state.coefficientScheme = payload
  }
}

var actions = {
  GET_COEFFICIENT_SCHEME: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/coefficient_scheme')
    if (result.status === 200) {
      context.commit('SET_COEFFICIENT_SCHEME', result.data)
    }
  },
  CREATE_COEFFICIENT_SCHEME: (context, payload) => {
    return axiosInstance.post('/tariffing/coefficient_scheme', payload)
  },
  UPDATE_COEFFICIENT_SCHEME: (context, payload) => {
    return axiosInstance.put('/tariffing/coefficient_scheme', payload)
  },
  DELETE_COEFFICIENT_SCHEME: (context, payload) => {
    return axiosInstance.delete('/tariffing/coefficient_scheme?coeff_scheme_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/coefficientScheme.js